export default __webpack_public_path__ + "static/media/main-background-mobile.12d7f063.svg";